import React from "react"
import PropTypes from "prop-types"
export const StarIcon = ({ height = 17, width = 16, fill = "#272A34", ...props }) => {
  const themeColor = "var(--color-primary)"
  return (
    <svg width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00065 1.83398L10.0607 6.00732L14.6673 6.68065L11.334 9.92732L12.1207 14.514L8.00065 12.3473L3.88065 14.514L4.66732 9.92732L1.33398 6.68065L5.94065 6.00732L8.00065 1.83398Z"
        fill={themeColor}
        stroke={themeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

StarIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}
